import Loading from "@/components/atomic/Loading";

const LoadingOverlay: React.FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <Loading />
    </div>
  );
};

export default LoadingOverlay;
